export default "__VITE_ASSET__C24eeaa9__"